import socailData from "./../data/socail-data";
import otherProfileData from "./../data/other-profile";

const LinkItem = ({ icon, link }) => {
  return (
    <li className="contacts__socail-icon__item">
      <a
        href={link}
        className="contacts__socail-icon__link"
        target="_blank"
        rel="noreferrer"
      >
        {icon}
      </a>
    </li>
  );
};

const Contacts = () => {
  const currentYear = new Date().getFullYear();

  return (
    <section className="section contacts">
      <h1 className="large-text contacts__text" data-drop-text="Get in touch">
        Get In Touch
      </h1>

      <div className="contacts__content">
        <div>
          <div className="medium-text mb-5  mb-phone-x-5"> Connect with me</div>
          <ul className="contacts__socail-icon__list">
            {socailData.map(({ icon, link }, idx) => {
              return <LinkItem key={idx} icon={icon} link={link} />;
            })}
          </ul>
        </div>

        <div>
          <div className="medium-text mb-5  mb-phone-x-5">Other Profile</div>
          <ul className="contacts__socail-icon__list">
            {otherProfileData.map(({ icon, link }, idx) => {
              return <LinkItem key={idx} icon={icon} link={link} />;
            })}
          </ul>
        </div>

        <div className="contacts__legal">
          <p className="small-x-text">©{currentYear}. All Rights Reserved.</p>
          <p className="small-x-text">
            Made By
            <a href="/" className="btn__link contacts__link" target="_blank">
              @MdGhulamAzadAnsari
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
